import { render, staticRenderFns } from "./noteTemplates.vue?vue&type=template&id=2725356a&scoped=true&"
import script from "./noteTemplates.vue?vue&type=script&lang=js&"
export * from "./noteTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2725356a",
  null
  
)

export default component.exports